import { createSelector } from 'reselect';
import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSetFilterAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import { BaseObjectFilters } from '../../store/bootstrap';
import * as fromLookupActions from './lookup.actions';
import { Lookup } from './lookup.model';

export interface LookupFilters extends BaseObjectFilters {
    lookupType: string;
}

export interface State {
    ids: Array<string>;
    entities: { [id: string]: Lookup };
    filters: LookupFilters;
}

export const initialState: State = {
    ids: [],
    entities: {},
    filters: {
        searchTerm: '',
        lookupType: '*',
        sortBy: 'title',
        sortDirection: 1
    }
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromLookupActions.Actions): State {
    switch (action.type) {
        case fromLookupActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromLookupActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromLookupActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case fromLookupActions.SET_FILTER: {
            return handleSetFilterAction(state, action);
        }
        default: {
            return state;
        }
    }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup/lookup.reducer.ts